
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea, CardContent, Container, Typography } from "@mui/material";
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import IniciaisLetras from '../../../utils/iniciaisLetras';
// import CardServices from '../../../utils/cardServices';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 100,
    marginBottom: 20,
    padding: 20,
    // background:'#85287e',

    display: "flex",
    alignItems: "center",
    minHeight: '40vh',
    backgroundImage: 'url(/img/backGrounds/BgComprimido2.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    boxShadow: '1rem 1rem 1rem #e7f0ed',
  },

  card: {
    textAlign: 'center',
    width: '16%',
    minWidth: 220,
    height: 200,
    // lineHeight: 1,
    // fontSize: 16, 

    backgroundColor: '#fff',
    // boxShadow: '1rem 1rem 1rem #e7f0ed',

    border: '1px solid #85287e',
    borderRadius: 10,
    transition: '.5s',
    '&:hover': { transform: 'scale(1.1)', border: '1px solid #000', },

    [theme.breakpoints.down('xs')]: {
      minWidth: 135,
      width: '45%',
      height: 180,
    },
  },
}))


export default function CarousselDestaques({ definicoesSistema }) {
  const classes = useStyles();

  function CardServices({ status, icone, nomeService, link }) {
    return (
      <Card>

        <CardActionArea disabled={!status} className={classes.card} >
          <Link style={{ textDecoration: 'none' }} to={link}>
            <CardContent>
              {icone ?
                <div style={{ height: 50, display: 'flex', alignItems: 'center' }}>
                  <img src={icone} alt={''} style={{ height: 75, margin: 'auto' }} />
                </div>
                :
                <Typography align="center" color="textSecondary" variant="h3" >
                  <IniciaisLetras frase={nomeService} />
                </Typography>
              }
            </CardContent>

            <CardContent >
              <Typography color="textPrimary" variant="body1" style={{ fontSize: '14px', textAlign: "center" }}>
                {nomeService}
              </Typography>
            </CardContent>
          </Link>
        </CardActionArea>
      </Card>
    )
  }


  const serviceStatus = (servico) => {
    if (definicoesSistema?.servicos.includes(servico)) return true;
  }

  return (
    <div className={classes.root} >

      <Container >

        <Typography align="center" variant="h1" style={{ margin: '1rem', fontSize: 25, fontWeight: 'bold', color: '#fff' }}>
          DESTAQUES
        </Typography>

        <Swiper
          breakpoints={{
            // Configurações quando a largura da tela for >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            // Configurações quando a largura da tela for >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            // Configurações quando a largura da tela for >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
            // ... Adicione mais breakpoints conforme necessário
          }
          pagination={{
            clickable: true,
          }}

          modules={[Pagination]}
          className="mySwiper"
        >

          <SwiperSlide key='1' >
            <CardServices status={serviceStatus('autorizados')} icone={'/icones/Medicamentos_autorizados.svg'} nomeService={'LISTA DE MEDICAMENTOS REGISTADOS EM ANGOLA ATÉ FEVEREIRO DE 2026'} link={'/medicamentos/aprovado?page=1'} />
          </SwiperSlide>

          <SwiperSlide key='2'>
            <CardServices status={serviceStatus('estabelecimentosLicenciados')} icone={'/icones/Licenciamento.svg'} nomeService={'LISTA DE ESTABELECIMENTOS FARMACÊUTICOS LICENCIADOS'} link={'/estabelecimentos-categorias-armed'} />
          </SwiperSlide>

          <SwiperSlide key='3'>
            <CardServices status={serviceStatus('registosMedicamentos')} icone={'/icones/registoMedicamentos.svg'} nomeService={'REGISTO DE MEDICAMENTOS'} link={'/informacoes-sobre-pedido-de-aim'} />
          </SwiperSlide>

        </Swiper>
      </Container>
    </div>
  )
}
